import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import moment from "moment";
import ShareSpaceManifest from "models/interfaces/share-spaces/share-space-manifest";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const defaultValues: ShareSpaceManifest =
    RecordUtils.auditableDefaultValuesFactory<ShareSpaceManifest>({
        title: "",
        description: "",
        sentOn: undefined,
        expiresOn: undefined,
        senderFirstName: undefined,
        senderLastName: undefined,
        senderEmail: undefined,
    });

// #endregion Constants

export default class ShareSpaceManifestRecord
    extends Record(defaultValues)
    implements ShareSpaceManifest
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: ShareSpaceManifest) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // #region Public Methods
    public isExpired(): boolean {
        return moment().isAfter(this.expiresOn);
    }
    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<ShareSpace>} values
     */
    public with(values: Partial<ShareSpaceManifest>): ShareSpaceManifestRecord {
        return new ShareSpaceManifestRecord(Object.assign(this.toJS(), values));
    }

    // #endredion Public Methods
}
